import React from 'react';
import DesktopDevPageSide300x250Fs from './freestar/DesktopDevPageSide300x250Atf';
const DesktopDevPageSide300x250Atf = ({ safety ='off' , safetyState  })=>{
    return /*#__PURE__*/ React.createElement(DesktopDevPageSide300x250Fs, {
        safety: safety,
        safetyState: safetyState
    });
};
DesktopDevPageSide300x250Atf.displayName = 'DesktopDevPageSide300x250Atf';
export default DesktopDevPageSide300x250Atf;
